import Model from "../Model";

class UserProjects extends Model {
    buildUrl ({query}) {
        return ['api/users/projects'];
    }
};

export default new UserProjects;